import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { JobLocationComponent } from './job-location.component';
import { MapComponent } from './map/map.component';
import { JobLocationStateModule } from './+state/job-location-state.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		JobLocationStateModule,
		LeafletModule,
	],
	declarations: [JobLocationComponent, MapComponent],
	exports: [JobLocationComponent],
})
export class JobLocationModule {}
